import { initFirebaseAnalytics, setApplicationType } from 'tw-oi-core/services/analytics'
import { GOOGLE_ANALYTICS_APP_TYPE, GOOGLE_ANALYTICS_FIREBASE_CONFIG } from '../config'

let initialized = false

export function initAnalyticsOnce() {
  if (initialized) return

  initFirebaseAnalytics(GOOGLE_ANALYTICS_FIREBASE_CONFIG)
  setApplicationType(GOOGLE_ANALYTICS_APP_TYPE)
  initialized = true
}
